ngOUC.controller('AppController', function ($scope, $log, $location, Properties) {
    // -----------------------------------------------------------------------------------------------------------------
    // Setup
    // -----------------------------------------------------------------------------------------------------------------

    // Copy some global variables out to the model.
    $scope.ouc = {
        base                : OucGlobals.base,
        pathToPropertyReport: OucGlobals.pathToPropertyReport,
        mediaDirectory      : OucGlobals.mediaDirectory,
        templatesDirectory  : OucGlobals.templatesDirectory
    };

    $scope.properties    = [];
    $scope.neighborhoods = [];
    $scope.favorites     = localStorage.getItem('favorites') ? JSON.parse(localStorage.getItem('favorites')) : [];
    $scope.searches      = localStorage.getItem('searches') ? JSON.parse(localStorage.getItem('searches')) : {};

    $scope.isNaN = isNaN;
    
    // -----------------------------------------------------------------------------------------------------------------
    // Focus a particular pane of the application
    // -----------------------------------------------------------------------------------------------------------------
    $scope.focus = function (pane) {
        $log.debug('focus()', pane);
        if ($('html').hasClass('focus-' + pane)) {
            pane = 'nothing';
        }

        $('html').removeClass().addClass('focus-' + pane);
    };

    $scope.subfocus = function (pane) {
        $log.debug('subfocus()', pane);
        $('body').removeClass().addClass('subfocus-' + pane);
    };

    // -----------------------------------------------------------------------------------------------------------------
    // Initialize the property filter and show all properties
    // -----------------------------------------------------------------------------------------------------------------
    $scope.initializeFilter = function () {
        $log.debug('initializeFilter()');

        $scope.filter = {
            saleorlease: 'all'
        }

        $scope.filterProperties();
    };

    // -----------------------------------------------------------------------------------------------------------------
    // Applies the current filter to the list of all properties, updating the properties shown on the map and sidebar
    // -----------------------------------------------------------------------------------------------------------------
    $scope.filterProperties = function () {
        $log.debug('filterProperties()', $scope.filter);

        angular.forEach($scope.filter, function (value, key) {
            if (value == '' || typeof value === 'undefined') {
                delete $scope.filter[key];
            }
        });

        // Obtain all properties filtered by the active filter
        Properties.all(function (result) {
            // Update the list of active properties. This will affect only the sidebar
            $scope.properties = result;

            if (!$scope.neighborhoods || $scope.neighborhoods.length == 0) {
                $scope.filterNeighborhoods();
            }

            // Update the list of active properties on the map
            $scope.updateMap();
        }, $scope.filter);
    };

    // -----------------------------------------------------------------------------------------------------------------
    // Applies the current filter to the list of all properties, updating the properties shown on the map and sidebar
    // -----------------------------------------------------------------------------------------------------------------
    $scope.filterNeighborhoods = function () {
        $log.debug('filterNeighborhoods()');
        let localSet = new Set();

        for (let property of $scope.properties) {
            if (property.neighborhood && property.neighborhood.length > 0) {
                localSet.add(property.neighborhood);
            }
        }

        $scope.neighborhoods = Array.from(localSet).sort();
    };

    // -----------------------------------------------------------------------------------------------------------------
    // Open the sort modal
    // -----------------------------------------------------------------------------------------------------------------
    $scope.sortModalOpen = function () {
        $log.debug('sortModalOpen()');
        $('.sort-control-container').addClass('active');
    };

    // -----------------------------------------------------------------------------------------------------------------
    // Close the sort modal
    // -----------------------------------------------------------------------------------------------------------------
    $scope.sortModalClose = function () {
        $log.debug('sortModalClose()');
        $('.sort-control-container').removeClass('active');
    };

    // -----------------------------------------------------------------------------------------------------------------
    // View a single property
    // -----------------------------------------------------------------------------------------------------------------
    $scope.seeProperty = function (id) {
        $log.debug('seeProperty()', id);

        $location.path(id);

        // Get the property
        Properties.one(id, function (property) {
            $scope.property        = property;
        });


        //$('.slick-initialized').hide();
        $('.slick-initialized').slick('unslick');

        setTimeout(function() {
            $('.property-image-slider').slick({
                arrows        : false,
                adaptiveHeight: true,
                fade          : false
            });
            $('.slick-initialized').fadeIn();
        }, 1);
    };

    // -----------------------------------------------------------------------------------------------------------------
    // Save search
    // -----------------------------------------------------------------------------------------------------------------
    $scope.saveSearch = function () {
        $log.debug('saveSearch()');

        var index;
        var copyOfFilter = angular.copy($scope.filter);

        delete copyOfFilter.$$hashKey;

        index = JSON.stringify(copyOfFilter).hashCode()

        if (index == 1752422597) {
            return false;
        }

        $scope.searches[index] = copyOfFilter;

        localStorage.setItem('searches', JSON.stringify($scope.searches));

        $scope.subfocus('saved')
    };

    // -----------------------------------------------------------------------------------------------------------------
    // Delete search
    // -----------------------------------------------------------------------------------------------------------------
    $scope.deleteSearch = function (index) {
        $log.debug('deleteSearch()');

        delete $scope.searches[index];

        localStorage.setItem('searches', JSON.stringify($scope.searches));
    };

    // -----------------------------------------------------------------------------------------------------------------
    // Load search
    // -----------------------------------------------------------------------------------------------------------------
    $scope.loadSearch = function (index) {
        $log.debug('loadSearch()');

        var copyOfFilter = angular.copy($scope.searches[index]);

        $scope.filter = copyOfFilter;

        $scope.filterProperties();

        $scope.subfocus('new')
    };

    // -----------------------------------------------------------------------------------------------------------------
    // Favorite a property
    // -----------------------------------------------------------------------------------------------------------------
    $scope.favoriteProperty = function (id) {
        $log.debug('favoriteProperty()', id);

        if ($scope.favorites.indexOf(id) == -1) {
            $log.debug('-- Adding');
            $scope.favorites.push(id);

            Properties.one(id, function (property) {
                property.favorite = true;
            });
        } else {
            $log.debug('-- Removing');

            $scope.favorites.splice($scope.favorites.indexOf(id), 1);

            Properties.one(id, function (property) {
                property.favorite = false;
            });
        }

        localStorage.setItem('favorites', JSON.stringify($scope.favorites));
    };

    // -----------------------------------------------------------------------------------------------------------------
    // Initialize favorites
    // -----------------------------------------------------------------------------------------------------------------
    $scope.initializeFavorites = function () {
        $log.debug('initializeFavorites()');

        angular.forEach($scope.favorites, function (id) {
            Properties.one(id, function (property) {
                property.favorite = true;
            });
        });
    };

    // -----------------------------------------------------------------------------------------------------------------
    // styleMenus
    // -----------------------------------------------------------------------------------------------------------------
    $scope.styleMenus = function () {
        $log.debug('styleMenus()');

        if ($('.industries-bar .active').length >= 1) {
            $('.menu-bar__industries-button').addClass('softlyLitBox');
        } else {
            $('.menu-bar__industries-button').removeClass('softlyLitBox');
        }

        if ($('.demographics-bar .active').length >= 1) {
            $('.menu-bar__demographics-button').addClass('softlyLitBox');
        } else {
            $('.menu-bar__demographics-button').removeClass('softlyLitBox');
        }

        if ($('.coverages-bar .active').length >= 1) {
            $('.menu-bar__coverages-button').addClass('softlyLitBox');
        } else {
            $('.menu-bar__coverages-button').removeClass('softlyLitBox');
        }
    };
    $scope.openContactURL = function() {
      try {
          var contactURL = $scope.property.brokerwebsite;
          window.open('http://' + contactURL, '_blank');return false;
      } catch (err) {
          alert(err);
      }
    }

    // -----------------------------------------------------------------------------------------------------------------
    // Startup
    // -----------------------------------------------------------------------------------------------------------------

    // Initialize the filter at start time
    $scope.initializeFilter();

    // Initialize the favorites
    $scope.initializeFavorites();

    // Select the first property if one is specified in the URL
    var mapUpdatedCalledAtLeastOnce = false;

    $scope.mapUpdated = function () {
        if (!mapUpdatedCalledAtLeastOnce) {
            var propertyId = $location.path().replace('/', '');

            if (propertyId) {
                $scope.highlightProperty(propertyId);
                $scope.focus('property');
                $scope.seeProperty(propertyId);
            }

            mapUpdatedCalledAtLeastOnce = true;
        }
    }
});
